import React, { Component } from "react";
import Select from 'react-select';
import moment from 'moment';
import DataTable from 'react-data-table-component';
import { NotificationManager, NotificationContainer } from 'react-notifications';
import ExportPDF from "./donation_by_payment_type_report_pdf.js";
import { Redirect, BrowserRouter, Route, Switch } from "react-router-dom";
import Logout from "./../../loginService/logout";
import CircularProgress from "@material-ui/core/CircularProgress";

const numberWithCommas_display = require('../service/excelService.js').numberWithCommas_display;

var service = require('../service/getinfo.js');
const customStyles = service.customStyles;
const config = require('../../config.js');
const backend = config.backend;


const tableStyles = {
  rows: {
    style: {
      minHeight: '35px', // override the row height
    }
  },
  headCells: {
    style: {
      paddingLeft: '16px', // override the cell padding for head cells
      paddingRight: '8px',
      fontWeight: 'bold',
      fontSize: '14px'
    },
  },
  cells: {
    style: {
      paddingLeft: '16px', // override the cell padding for data cells
      paddingRight: '8px',
      fontSize: '14px'
    },
  },
};

const columns = [
  {
    name: 'Batch',
    selector: 'Description',
    grow: 2,
    wrap: true
  },
  {
    name: 'VBM',
    selector: 'BatchID',
  },
  {
    name: 'DATE',
    selector: 'TransactionDate',
    width: '130px',
    wrap: true,
    // sortable: true
  },
  {
    name: 'CHEQUE',
    selector: 'CHEQUE',
    right: true,
    cell: row => {
      if (row.CHEQUE) return (<div>${numberWithCommas_display(row.CHEQUE)}</div>)
    }
  },
  {
    name: 'CHQ_SPLIT',
    selector: 'CHQ_SPLIT',
    right: true,
    cell: row => {
      if (row.CHQ_SPLIT) return (<div>${numberWithCommas_display(row.CHQ_SPLIT)}</div>)
    }
  },
  {
    name: 'CASH',
    selector: 'CASH',
    right: true,
    cell: row => {
      if (row.CASH) return (<div>${numberWithCommas_display(row.CASH)}</div>)
    }
  },
  {
    name: 'GIRO',
    selector: 'GIRO',
    right: true,
    cell: row => {
      if (row.GIRO) return (<div>${numberWithCommas_display(row.GIRO)}</div>)
    }
  },
  {
    name: 'TRANSFER',
    selector: 'BANK_TRANS',
    right: true,
    cell: row => {
      if (row.BANK_TRANS) return (<div>${numberWithCommas_display(row.BANK_TRANS)}</div>)
    }
  },
  {
    name: 'CREDITCARD',
    selector: 'CREDITCARD',
    right: true,
    grow: 2,
    cell: row => {
      if (row.CREDITCARD) return (<div>${numberWithCommas_display(row.CREDITCARD)}</div>)
    }
  },
  {
    name: 'CC_SPLIT',
    selector: 'CC_SPLIT',
    right: true,
    cell: row => {
      if (row.CC_SPLIT) return (<div>${numberWithCommas_display(row.CC_SPLIT)}</div>)
    }
  },
  {
    name: 'CC_COVER',
    selector: 'CC_COVER',
    right: true,
    cell: row => {
      if (row.CC_COVER) return (<div>${numberWithCommas_display(row.CC_COVER)}</div>)
    }
  },
  {
    name: 'TOTAL',
    selector: 'BatchTotal',
    right: true,
    wrap: true,
    grow: 2,
    cell: row => {
      if (row.BatchTotal) return (<div>${numberWithCommas_display(row.BatchTotal)}</div>)
    },
    style: {
      fontWeight: 'bold'
    },
  },
];


class Donations_By_Payment_Type_Report extends Component {

  constructor(props) {
    super(props);

    this.state = {
      months: [],
      years: [],
      month: '',
      year: '',
      checked: false,
      errors: {},
      loading: 'true',
      isButtonDisabled: false,
      redirectLogout: false
    }
  }

  _isMounted = false;


  componentDidMount() {
    this._isMounted = true;
    this.renderMonth();
    this.renderYear();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  renderMonth = _ => {
    service.getMonthList()
      .then((months_drop) => {
        if (this._isMounted) {
          this.setState({ months: months_drop });
        }
      })
  }

  renderYear = _ => {
    service.getYearList()
      .then((years_drop) => {
        ;
        if (this._isMounted) {
          this.setState({ years: years_drop });
        }
      })
  }

  handleMonthChange = (m) => {
    var month = parseInt(m.value, 10) + 1
    this.setState({ month: month });
  }

  handleYearChange = (y) => {
    this.setState({ year: y.value });
  }


  getDonationsByPaymentType(startDate, endDate) {

    var that = this;

    return new Promise(function (resolve, reject) {

      var url = `api/v1/donation-batch?start=` + startDate + `&end=` + endDate;

      fetch(backend + url, {
        method: 'GET',
        credentials: "include"
      })
        .then(response => response.json())
        .then(response => {
          if (response.redirect) {
            that.setState({ redirectLogout: true })
            window.location.reload(false);
          }
          else if (response.status === 500) {
            reject(response.message)
          }
          else {
            resolve(response)
          }
        })
        .catch((err) => {
          reject(err)
        })

    })
  }


  inputValid = () => {
    let errors = {};
    let formIsValid = true;

    const { year } = this.state;
    const { month } = this.state;

    if (!(isFinite(String(year)) && year !== '')) {
      errors['year'] = 'Please choose a year!';
      formIsValid = false;
    }

    if (!(isFinite(String(month)) && month !== '' && month !== null)) {
      errors['month'] = 'Please choose a month!';
      formIsValid = false;
    }

    if (month > moment().format("MM") && year >= moment().format("YYYY")) {
      errors['month'] = 'Out of range!';
      formIsValid = false;
    }

    this.setState({ errors: errors });
    return formIsValid;
  }


  getReport = _ => {
    let { month } = this.state;
    let { year } = this.state;

    var startDate = moment([year, month - 1]).format("YYYY-MM-DD");
    var endDate = moment(startDate).endOf('month').format("YYYY-MM-DD");

    this.setState({ multiData: {} });

    this.setState({ checked: false })

    if (this.inputValid()) {

      this.setState({ checked: true })

      this.getDonationsByPaymentType(startDate, endDate)
        .then((result) => {
          this.setState({ multiData: result });
        })
        .catch((error) => {
          this.setState({ multiData: 'error' });
          NotificationManager.error(error.toString());
        });
    }
  }

  renderReport() {
    const { multiData } = this.state;
    let checked = this.state.checked;
    // var filename = 'Donations By Payment Types';

    if (checked) {

      if (multiData === 'error') {
        return <h4 className='title'> Cannot get data from database... </h4>
      }
      else if (multiData && Object.keys(multiData).length) {
        // console.log('multiData is updated', multiData);

        multiData['columns'] = columns;
        const title = multiData.title;
        const table_data = multiData.data;
        // const table_deduct = multiData.deduct;

        return (<div>

          <ExportPDF data={multiData} />

          <DataTable
            highlightOnHover
            title={title}
            columns={columns}
            data={table_data}
            customStyles={tableStyles}
          />

        </div>);
      }
      else {
        return (
          <div style={{display:"flex", alignItems: "center", justifyContent: "center"}}>
          <h4 className='title'>Loading... This may take a while... </h4>
          <CircularProgress/>
          </div>
        )
      }
    }
  }


  render() {

    const { redirectLogout } = this.state;

    if (redirectLogout) {
      return (
        <BrowserRouter>
          <Switch>
            <Route exact path="/logout" component={Logout} />
            <Redirect to="/logout" />
          </Switch>
        </BrowserRouter>
      )
    }

    const { years } = this.state;
    const { months } = this.state;
    let report_table = this.renderReport();

    return (
      <div className="sorted-donation-report">
        <h3 className="title">Donations by Payment Type Report</h3>
        <div className="form-set row">
          <form className="form-horizontal">
            <div className="form-sets col-sm-12">
              <fieldset>
                <div className="fieldset">

                  <div className="buttons col-sm-4">
                    <div className="btn-group">
                      <Select className='react-select-container' styles={customStyles} options={months} isSearchable="false" placeholder="months" onChange={this.handleMonthChange} />
                      <span className="error">{this.state.errors["month"]}</span>
                    </div>
                  </div>
                  <div className="buttons col-sm-4">
                    <div className="btn-group">
                      <Select className='react-select-container' styles={customStyles} options={years} isSearchable="false" placeholder="year" onChange={this.handleYearChange} />
                      <span className="error">{this.state.errors["year"]}</span>
                    </div>
                  </div>

                  <div className="col-sm-4 check-button">
                    <button type="button" className="btn btn-primary submit" disabled={this.state.isButtonDisabled} onClick={this.getReport}>CHECK</button>
                  </div>

                </div>
              </fieldset>
            </div>
          </form>
        </div>

        <div className="report-table" id="reserve-table">
          {report_table}
        </div>
        <NotificationContainer />

      </div>);
  }
}


export default Donations_By_Payment_Type_Report;
